export default "__VITE_ASSET__TY$vYyly__"